import { CreditAssist } from "@Redux/Manual_Kyc_Details/action";
import React, { useState , useEffect} from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import imageGif from "../../../Images/RefusedDocument.gif";
import Crossimage from "../../../Images/NewUI/crossx.png"
import imageArrow from "../../../Images/imageSuperArrow.png";
// Removed - CAStatus API no longer needed

function ModalFailed(props) {
  const [modalState, setModalState] = useState(true);
  const [btnName, setBtnName] = useState("")
  const returnFn = () => {
    return "sen";
  };
  useEffect(() => {
    // Removed - CAStatus API call no longer needed
  }, []);

  // Removed - handleCAstatus function no longer needed

  const dashboardRedirect = () => {
    setTimeout(() => {
     
    }, 1000);
    setTimeout(()=>{ window.location.href = "/dashboard_s"}, 2000)
   
  };
  const creditAssistRedirection = () => {
    const token =
      props?.user?.User?.token || localStorage.getItem("gpay_token");
    setTimeout(() => {
      
    }, 1000);

    props
      .CreditAssist(token)
      .then((res) => {
        console.log(res.data.url, "crediturlllll");
        var url = res.data.url;
        window.open(url, "_blank");
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        // console.log(err);
      });

    // setModalState(false)
  };
  return (
    <>
    <div
      className="modalFail"
      style={{ display: "flex", justifyContent: "center" }}
    >
      <Modal
        className="dial"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        show={true}
      >
        <div className="modalContainer max-width-modal">
          <img
            onClick={dashboardRedirect}
            className="float-right"
            src={Crossimage}
            alt="crossimage"
          />
          {/* <span onClick={dashboardRedirect} className="float-right">x</span> */}
          <span className="modalSpan colouReject">
            Loan Application Rejected !
          </span>
         <div className="heroloanrejectpopupbox">
         <img
            className=""
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            height="100"
            width="115"
            src={imageGif}
          />
         
          <div className="modalLine">
            {/* <p className="spanText">Following might be the reasons:</p> */}
            {/* <p className="spanTextBold">Credit Assist</p> */}
          </div>


          <div className="rightArrowBox mb-22">
           
            {btnName !== "PAY_NOW" && btnName !== "VIEW" ?
          <p className="spanText mbottom-10 align-start">Following might be the reasons:</p>:
          <p className="loanrejectviewheading">But here’s some good news!  </p>
            }

{btnName !== "PAY_NOW" && btnName !== "VIEW" ?
            <p className="sidePoint">
              <img height={12} width={12} src={imageArrow} />
              <span className="imageCredit"><span className="imageCreditcolour">Bureau: </span> Low credit score or credit history issues.</span>
            </p>
:
            <span className="loanrejectviewtext mb-20">We’re already helping you build and improve your credit score. </span>}
            
            {btnName !== "PAY_NOW" && btnName !== "VIEW" ?
            <p className="sidePoint">
              <img height={12} width={12} src={imageArrow} />
              <span className="imageCredit">
              <span className="imageCreditcolour"> Banking: </span> Income pattern doesn’t align with policy.
              </span>
            </p>
:
            <span className="loanrejectviewtext">Let’s continue with your personalized, tailored suggestions to boost / build your score.</span>}

{btnName !== "PAY_NOW" && btnName !== "VIEW"?
            <p className="sidePoint">
              <img height={12} width={12} src={imageArrow} />
              <span className="imageCredit"> <span className="imageCreditcolour">Policy: </span> Financial status doesn’t meet criteria.</span>
            </p>:""}
          </div>
         </div>

         {/* {btnName !== "PAY_NOW" && btnName !== "VIEW" ?  
<div className="maxwidthloanreject">
<span className="loanrejectNewtext">Don’t worry! Improve your <span className="imageCreditcolour">Credit Score</span> to boost your chances next time. 
We’re here to help.</span>
</div>:""} */}


          {/* <div
            onClick={() => {
              creditAssistRedirection();
            }}
            className="tryButton"
          >
            {btnName !== "PAY_NOW" && btnName !== "VIEW" ?
            "Try Now" :
            "Continue" }
          </div> */}
        </div>
      </Modal>
    </div>
    </>
  );
}

const mapStateToProps = (state) => {
  // console.log("state state", state);
  return {
    user: state.user,
    userDetail: state.userDetail,
  };
};
export default connect(mapStateToProps, {
  CreditAssist,
})(ModalFailed);
